import React, { useContext, useEffect, useState, useRef } from "react";
import { Button, Col, Row } from "antd";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowsRotate,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const DashboardFornecedor = (props) => {

  const styles = `
  .Maquinas-page {
    background-color: black;
    color: white;
    margin: 0;
    padding: 0;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;     
  }
  .Maquinas-page .Cliente_atualizar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 20px;
    gap: 15px;
    padding-bottom: 25px;
  }
  .Cliente_title {
    font-family: 'Arial', sans-serif;
    font-size: 30px; 
    font-weight: bold; 
    color: #c8dd06; 
    padding: 12px 25px;
    display: flex;
    justify-content: center; 
    line-height: 1;
  }
  .Botao-Sair {
    font-size: 20px;
    padding: 20px;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    background-color: rgb(250, 3, 3);
    color: white;
    margin: 0 20px;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #ffffff;
  }
  .Botao-Sair:hover {
    background-color: rgb(252, 70, 70);
  }
  .Maquinas-page .buttons button i {
    margin-right: 5px;
  }
  .machines {
    flex: 1 1 calc(25% - 10px); 
    max-width: calc(25% - 10px); 
    display: flex;
    flex-direction: column;
    margin: 5px; 
    transition: all 0.3s ease; 
  }
  .maquina {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  min-width: 150px;
  flex-grow: 1;
  color: #000000;
  transition: transform 0.2s ease, height 0.3s ease;
  overflow: hidden;
  max-height: 110px;
  word-wrap: break-word;
  white-space: pre-wrap;
  }
 .maquina.expanded {
  font-family: 'Liberation Mono', monospace; 
  max-height: 500px;
  flex: 1 1 100%;
  }
 .maquina h2.nome {
  font-size: 34px;
  font-family: 'arial';
  margin-bottom: 1px; /* Reduz o espaço abaixo do nome */
  line-height: 1.2; /* Ajusta a altura da linha do nome */
 }
 .maquina h4.descricao {
  font-size: 30px;
  font-family: 'arial';
  margin-top: 1px; /* Reduz o espaço acima da descrição */
  line-height: 1.2; /* Ajusta a altura da linha da descrição */
  }
  .no-machines {
    margin-left: 30px;
    font-size: 30px;
    color: white;
    text-align: center;
  }
.button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
  padding: 0 20px;
}
.botao {
  width: 100%; 
  padding: 20px;
  text-align: center;
  min-height: 80px; /* Altura mínima para garantir consistência */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-sizing: border-box; /* Garante que padding não ultrapasse o width/height */
}
@media only screen and (max-width: 1020px) and (orientation: landscape) {
  .machines {
    flex: 1 1 calc(50% - 10px); 
    max-width: calc(50% - 10px);
  }  
  .botao {
    width: calc(50% - 10px); /* Dois botões por linha */
    padding: 20px;
    font-size: 30px;
  }
}
  @media only screen and (max-width: 760px) and (orientation: portrait) {
   .machines {
    flex: 1 1 100%; 
    max-width: 100%; 
   }
   .Cliente_title {
    margin-left: 0;
    text-align: center;
    width: 100%;
   }
   .botao {
    width: 100%; /* Um botão por linha */
    padding: 20px;
    height: 70px; /* Altura fixa maior */
    font-size: 30px;
   }
   .Botao-Sair,
   .Botao-Atualizar,
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    width: 100%; 
   }
  }
}


  `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;
  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const [totalFornecedores, setTotalFornecedores] = useState([]);
  const [expandedLine, setExpandedLine] = useState(null); // Linha atualmente expandida

  const dataData = () => {
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/maquinas`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (Array.isArray(res.data)) {
            setTotalFornecedores(res.data);
          } else {
            console.error("Os dados recebidos da API não são um array:", res.data);
            setTotalFornecedores([]); 
          }
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        if ([401, 403].includes(err.response?.status)) {
          setNotiMessage({
            type: "error",
            message:
              "Sua sessão expirou, faça login novamente. 09",
          });
          setDataUser(null);
        } else {
          console.error("Erro ao buscar dados da API:", err);
          setTotalFornecedores([]); 
        }
      });
  };

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    // Limpar o intervalo quando o componente for desmontado para evitar vazamento de memória
    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, []);

  const maquinaRefs = useRef([]);

  // Função para expandir/retrair uma linha
  const toggleExpandLine = (lineIndex) => {
    if (expandedLine === lineIndex) {
      setExpandedLine(null); // Retrai a linha se já estiver expandida
    } else {
      setExpandedLine(lineIndex); // Expande a linha
    }
  };

  const handleMachineClick = (lineIndex, post) => {
    const maquinaElement = maquinaRefs.current[post.id];
    if (maquinaElement) {
      const isOverflowing = maquinaElement.scrollHeight > maquinaElement.clientHeight;
      const heightDifference = maquinaElement.scrollHeight - maquinaElement.clientHeight;
      if (isOverflowing && heightDifference > 20) {
        toggleExpandLine(lineIndex);
      } else {
        navigate(`/pagamentos/${post.id}`, {
          state: { maquinaInfo: post },
        });
      }
    }
  };

  const handleLogout = () => {
    setDataUser(null);
    navigate("/");
  };

  const groupMachinesIntoLines = (machines, machinesPerLine = 4) => {
    if (!Array.isArray(machines)) {
      console.error("Entrada inválida para groupMachinesIntoLines:", machines);
      return []; // Retorna um array vazio em caso de erro
    }
  
    const lines = [];
    for (let i = 0; i < machines.length; i += machinesPerLine) {
      lines.push(machines.slice(i, i + machinesPerLine));
    }
    return lines;
  };

  const machineLines = groupMachinesIntoLines(totalFornecedores);

  return (

    <div className="Maquinas-page">

      <div className="WarningMsgSpan">
        <span>{dataUser.warningMsg}</span>
      </div>

      <div className="Cliente_atualizar">

        <div className="Cliente_title">
          MONITORAMENTO
        </div>

        <div className="Cliente_vencimento">
          {dataUser?.vencimento && (() => {
            const isVencida = moment().isAfter(moment(dataUser.vencimento));
            return (
              <span className={isVencida ? "vencida" : "nao-vencida"} style={{ fontFamily: 'Arial', fontSize: '28px', fontWeight: 'bold', margin: 0, padding: 0, display: 'flex', alignItems: 'center', lineHeight: 1, color: isVencida ? 'rgb(253, 4, 4)' : 'rgb(1, 189, 1)' }}>
                {isVencida
                  ? `MENSALIDADE VENCIDA: ${moment(dataUser.vencimento).format("DD/MM/YYYY")}`
                  : `VENCIMENTO: ${moment(dataUser.vencimento).format("DD/MM/YYYY")}`}
              </span>
            );
          })()}
        </div>

        <div className="button-container">
          <Button
            className="Botao-Sair"
            onClick={handleLogout}
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>SAIR</span>
          </Button>
        </div>
      </div>

      <Row>
  {Array.isArray(machineLines) &&
    machineLines.map((line, lineIndex) => (
      <React.Fragment key={lineIndex}>
        {Array.isArray(line) &&
          line.map((post) => {
            const backgroundColor =
              post.status.toLowerCase() === "online"
                ? "linear-gradient(to bottom, #50ca1b 60%, #a8e063 100%)"
                : post.status.toLowerCase() === "offline"
                  ? "linear-gradient(to bottom, #ff0000 60%, #ff6666 100%)"
                  : post.status.toLowerCase() === "pagamento_recente"
                  ? "linear-gradient(to bottom,rgb(6, 132, 250) 60%,rgb(57, 190, 252) 100%)"
                    : "rgb(250, 172, 4)";

            return (
              <Col className="machines" key={post.id}>
                <div
                  ref={(el) => (maquinaRefs.current[post.id] = el)}
                  className={`maquina ${expandedLine === lineIndex ? "expanded" : ""}`}
                  style={{
                    background: backgroundColor,
                  }}
                  onClick={() => handleMachineClick(lineIndex, post)}
                >
                  <h2 className="nome">{post.nome}</h2>
                  <h4 className="descricao">{post.descricao}</h4>
                </div>
              </Col>
            );
          })}
      </React.Fragment>
    ))}
</Row>
    </div>
  );
};

export default DashboardFornecedor;
